import React, {Component} from "react";
import {getPrefixedUrl} from "../../../utils/utils";
import {IconButton, Stack} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import {TransformComponent, TransformWrapper} from "react-zoom-pan-pinch";
import {addWheelListener} from "../../../utils/listeners";

class PathForMask extends Component {

    constructor(props) {
        super(props);

        this.imageRef = React.createRef();
    }

    componentDidMount() {
        addWheelListener(document, this.onWheel);
    }


    render() {
        let maskForPathUrl = getPrefixedUrl(`pre-processed/overlayed_mask_for_path.jpg`, this.props.slide);

        return <Stack direction={"column"} height={"100%"} spacing={3} padding={2}>
            <Stack direction={"row"} justifyContent={"space-between"}>
                <Typography variant={"h4"} color={"white"} align={"center"}></Typography>
                <IconButton type="primary" color={"error"} align={"right"} onClick={this.props.onImageClose}>
                    <CloseIcon sx={{color: "red"}}/>
                </IconButton>
            </Stack>
            <TransformWrapper ref={this.imageRef} initialScale={2}
                              wheel={{step: 0.3}}
                              minScale={0.8} maxScale={8}>
                <TransformComponent wrapperStyle={{
                    borderStyle: 'solid', borderWidth: '4px', width: '100%',
                    height: '100%', borderColor: '#03112c',
                    backgroundColor: '#03112c'
                }}>
                    <img
                        src={maskForPathUrl} alt="Image"
                        style={{
                            width: '650px',
                            height: '380px',
                            rotate: '-270deg',
                            marginTop: "80px",
                            marginBottom: "80px"
                        }}
                    />
                </TransformComponent>
            </TransformWrapper>
        </Stack>
    }
}

export default PathForMask;